module.exports = __webpack_public_path__ + "static/media/body_detection_demo.da80a355.png";